var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ranking-board"}},[_c('div',{staticClass:"ranking-board-title"},[_vm._v("各分公司总人数")]),_c('dv-scroll-ranking-board',{key:_vm.key,staticStyle:{"width":"100%","height":"600px"},attrs:{"config":_vm.val}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }